<template>
  <el-card>
    <el-row class="common-row">
      <el-col :span="8">
        <span>名称：</span>
        <el-input
            class="search-item"
            placeholder="请输入"
            clearable
            v-model="name"
            size="small"
        ></el-input>
      </el-col>
      <el-col :span="14">
        <el-button class="btn-search" round icon="el-icon-search" @click="search" size="small">搜索</el-button>
      </el-col>
    </el-row>
    <el-row class="common-margin">
      <el-table
          :data="tableData"
          :max-height="tableHeight"
          style="width: 100%"
          border
      >
        <el-table-column type="index" width="80px" align="center" label="序号"> </el-table-column>
        <el-table-column prop="name" align="center" label="名称"></el-table-column>
        <el-table-column prop="logo" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                v-if="scope.row.logoSrc"
                style="width: auto;height: 20px"
                :src="scope.row.logoSrc"
                :preview-src-list="scope.row.logoList"
                fit="contain"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="category" align="center" label="品类"> </el-table-column>
        <el-table-column prop="address" align="center" label="地址"> </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="text"
                @click="enroll(scope.row.id)"
            >报名</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes"
          :total="total"
      >
      </el-pagination>
    </el-row>

    <el-dialog width="40%" :close-on-click-modal="false" :modal="false" :visible.sync="visible">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="120px" class="add-form">
        <el-form-item prop="contacts" label="联系人：">
          <el-input v-model.trim="form.contacts"></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="手机号：">
          <el-input v-model.trim="form.phone"></el-input>
        </el-form-item>
        <el-form-item prop="email" label="说明：">
          <el-input v-model.trim="form.email" type="textarea" :rows="6"></el-input>
        </el-form-item>
        <div class="info-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>

export default {
  name: 'index',
  props: ['activityId', 'listType'],
  data () {
    return {
      id: '',
      tableData: [],
      tableHeight: 0,
      name: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      visible: false,
      meetRecordId: '',
      form: {
        sessionId: '',
        compositeId: '',
        phone: '',
        contacts: '',
        email: ''
      },
      rules: {
        phone: {
          required: true,
          message: '请填写手机号码',
          trigger: 'blur'
        },
        contacts: {
          required: true,
          message: '请填写联系人',
          trigger: 'blur'
        },
        email: {
          required: true,
          message: '请填写说明',
          trigger: 'blur'
        }
      }
    }
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 360
    this.getPageList()
  },
  methods: {
    async getPageList () {
      let {data: res} = await this.$http.post('meetSession/meetSession/brandRegistrationList', {
        meetSessionId: this.activityId,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === '200') {
        this.tableData = res.data.records
        this.tableData.forEach(item => {
          if (item.logo) {
            item.logoList = item.logo.split(',')
            item.logoSrc = item.logo.split(',')[0]
          } else {
            item.logoSrc = ''
            item.logoList = []
          }
        })
        this.total = Number(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    async enroll (meetRecordId) {
      this.form.sessionId = this.activityId
      this.form.compositeId = meetRecordId
      this.visible = true
    },
    search () {
      this.currentPage = 1
      this.getPageList()
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    cancel () {
      this.visible = false
      this.form = {
        sessionId: '',
        compositeId: '',
        phone: '',
        contacts: '',
        WeChat: '',
        email: ''
      }
    },
    save () {
      this.$refs.formRef.validate(async (val) => {
        if (val) {
          let { data: res } = await this.$http.post('meetSession/meetSession/addActivityRegistrationBrand', this.form)
          if (res.code === '200') {
            this.visible = false
            this.$message.success(res.msg)
            this.$emit('updateList')
          } else {
            this.$message.error(res.msg)
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/meetSession/activityList.vue